
<style>
  .Special{
    background-color:#ff9595 !important;
  }

</style>

<div class="col-md-12 mb-30" *ngIf="Data_View_Customer.id==0">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Comments </h5>
     <br/>

     <div class="row">

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Customer Name  </label>
        <input [(ngModel)]="Name" type="text" class="form-control"  placeholder="Type here to search...">

      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Field of Activity</label>
        <select class="custom-select" [(ngModel)]="FeildActivityId">
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_FeildActivity" [value]="item.id">{{item.title}}</option>
        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Province </label>
        <select class="custom-select" [(ngModel)]="ProvinceId"  (change)="ProvinceChange()">
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">County</label>
        <select class="custom-select" [(ngModel)]="CityId" >
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1"> Customer Type </label>
        <select class="custom-select" [(ngModel)]="SearchCommentType">
          <option value="0">All Customers</option>
          <option value="1">Customers without Comments</option>
          <option value="2">Customers with Comments</option>
        </select>
      </div>

    </div>

     <div class="row">
      <div  class="form-group col-md-12" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Customer()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Customer Name</th>
              <th>Customer Code</th>
              <th>Created By</th>
              <th>Creation Date</th>
              <th>Edited By</th>
              <th>Edit Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>

              <td>{{item.code}}</td>

              <td>{{item.create_user}} </td>
              <td>{{item.create_date}} </td>
              <td>{{item.update_user}} </td>
              <td>{{item.update_date}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" class="dropdown-item" (click)="OpenNoteDialog(templateComment,item)"><i class="fa fa-pencil"></i> Add Comment </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Customer_view(item)"><i class="fa fa-file"></i> View Comments </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Customer"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<app-CutomerCommentView
  *ngIf="Data_View_Customer.id>0"
  (OnBack_Comment_Action)="OnBack_Comment_Action_Rest($event)"
  [Customer_Inner]="Data_View_Customer">

</app-CutomerCommentView>


<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Add Comment for Customer '{{Data_Seleted_Customer.name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Note.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <textarea type="text" class="form-control" [(ngModel)]="Note_Dsc" placeholder="Type here...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="SubmitNote()">
      Submit </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Note.hide()">Close</button>
  </div>
</ng-template>
